"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

function measureScrollbar() {
  var scrollDiv = document.createElement('div');
  scrollDiv.className = 'uiFullScreen-scrollbar-measure';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

var ScrollLock =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ScrollLock, _React$Component);

  function ScrollLock() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ScrollLock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ScrollLock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.disableBackgroundScrolling = function () {
      _this.addFauxScrollbar();

      _this.originalDocumentOverflow = document.documentElement.style.overflow;
      _this.originalBodyOverflow = document.body.style.overflow;
      document.documentElement.style.overflow = 'hidden';
    };

    _this.restoreBackgroundScrolling = function () {
      document.documentElement.style.overflow = _this.originalDocumentOverflow;
      document.body.style.overflow = _this.originalBodyOverflow;
      document.body.style.paddingRight = _this.originalBodyPaddingRight;

      _this.removeFauxScrollbar();
    };

    _this.addFauxScrollbar = function () {
      var bodyHasScrollbar = document.body.clientWidth < window.innerWidth;

      if (bodyHasScrollbar) {
        var scrollbarWidth = measureScrollbar() + "px";
        _this.originalBodyPaddingRight = document.body.style.paddingRight;
        document.body.style.paddingRight = scrollbarWidth;
      }
    };

    _this.removeFauxScrollbar = function () {
      document.body.style.paddingRight = _this.constructor.originalBodyPaddingRight;
    };

    return _this;
  }

  (0, _createClass2.default)(ScrollLock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.disableBackgroundScrolling();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.restoreBackgroundScrolling();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return ScrollLock;
}(_react.default.Component);

var _default = ScrollLock;
exports.default = _default;
module.exports = exports.default;